<template>
  <div class="feed" ref="scrollComponent">
    <template v-if="'success' == status">
      <div class="feed-featured">
        <div
          v-if="items.length"
          class="post-list divide-y divide-lightest-gray"
        >
          <ListItem :key="items[0].id" :post="items[0]" />
        </div>
      </div>

      <template
        v-if="
          showSlot && getSidebarContent('in-feed-term-tabs-slot-one').length
        "
      >
        <RenderHtml :html="getSidebarContent('in-feed-term-tabs-slot-one')" />
      </template>
      <div v-if="items.length" class="feed-trending-posts">
        <OrbitPosts
          :key="trendingPostsParams"
          :params="trendingPostsParams"
          @totalItemsUpdated="onTotalTrendingPostsUpdate"
        />
      </div>
      <template
        v-if="
          showSlot && getSidebarContent('in-feed-term-tabs-slot-two').length
        "
      >
        <RenderHtml :html="getSidebarContent('in-feed-term-tabs-slot-two')" />
      </template>

      <div
        class="pb-4 mb-8 border-b border-lightest-gray"
        v-if="showHorizontalLine"
      ></div>

      <div class="feed-body">
        <div class="post-list divide-y divide-lightest-gray">
          <template v-for="item in items.slice(1)" :key="item.id">
            <ListItem :post="item" />
          </template>
        </div>
      </div>
    </template>
    <PostListAnimation v-else />
    <p
      v-if="!items.length && status == 'success'"
      class="text-gray font-thin mb-8 mt-2 heading-font"
    >
      Curate your newsfeed. Click on the + icon and follow top categories on
      Youth Ki Awaaz.
    </p>
  </div>
</template>
<script>
import { useRoute } from "vue-router";
import { computed, onMounted, onUnmounted, ref } from "vue";

import API from "@/api";
import Util from "@/lib/Util";
import OrbitQuery from "@/lib/OrbitQuery";
import RenderHtml from "@/lib/RenderHtml.vue";
import ListItem from "@/templates/post-list/Item.vue";
import PostListAnimation from "@/components/animation/PostListAnimation.vue";

export default {
  props: {
    params: Object,
  },
  components: { ListItem, RenderHtml, PostListAnimation },
  setup(props) {
    const settings = window?.ykasettings ?? {};
    const route = useRoute();
    const totalTrendingPosts = ref(0);

    const sanitizedParams = computed(() => {
      var params = Util.removeEmptyParams(
        JSON.parse(JSON.stringify(props.params)),
      );

      delete params["style"];
      params.pagination = 1;
      params.post_type = "posts";

      return params;
    });

    const trendingPostsParams = computed(() => {
      const params = {
        ...sanitizedParams.value,
        pagination: 0,
        post_type: "posts",
        style: "TrendingPostScroll",
        // Feed component is being used in a lot of places
        // So, the updated params should be only used in Home and Newsfeed routes.
        ...(["Home", "Newsfeed"].includes(route.name) && {
          ...settings?.term_tabs_shortcode?.trending_post_atts,
        }),
      };

      delete params.feed;

      return params;
    });

    const requestAPI = (params) => {
      if (params?.feed == "newsfeed") {
        return API.requestNewsfeed(params.post_type, params);
      } else if (params?.feed == "following-authors-posts") {
        return API.requestFollowingAuthorsPosts(params);
      }

      return API.requestPosts(params.post_type, params);
    };

    const { items, status, watchScroll, scrollComponent, totalItems } =
      OrbitQuery(sanitizedParams.value, requestAPI);

    const showSlot = computed(
      () => totalItems.value && props.params.style === "Feed",
    );

    const showHorizontalLine = computed(() => {
      if (!totalItems.value) {
        return false;
      } else if (props.params.style === "Feed") {
        return !(
          totalTrendingPosts.value ||
          (settings?.sidebars &&
            (settings?.sidebars["in-feed-term-tabs-slot-one"] ||
              settings?.sidebars["in-feed-term-tabs-slot-two"]))
        );
      } else {
        return !totalTrendingPosts.value;
      }
    });

    const getSidebarContent = (sidebarId) =>
      settings?.sidebars[sidebarId] ? settings.sidebars[sidebarId] : "";

    const onTotalTrendingPostsUpdate = (total) =>
      (totalTrendingPosts.value = total);

    const handleScroll = () => {
      Util.debounceEvent(function () {
        watchScroll();
      }, 50);
    };

    onMounted(() => {
      if (sanitizedParams.value.pagination) {
        window.addEventListener("scroll", handleScroll);
      }
    });

    onUnmounted(() => {
      if (sanitizedParams.value.pagination) {
        window.removeEventListener("scroll", handleScroll);
      }
    });

    return {
      items,
      status,
      showSlot,
      scrollComponent,
      getSidebarContent,
      showHorizontalLine,
      trendingPostsParams,
      onTotalTrendingPostsUpdate,
    };
  },
};
</script>
